import { Trainer } from "../components/trainer/trainer";

export function TrainerPage() {
  return <Trainer />;
}
